import { render, staticRenderFns } from "./AppContent.vue?vue&type=template&id=4fa09dd7&scoped=true"
import script from "./AppContent.vue?vue&type=script&lang=ts"
export * from "./AppContent.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fa09dd7",
  null
  
)

export default component.exports